<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="ma-auto">
    <v-card class="main-card">
      <v-img class="white--text align-end" height="200px" src="@/assets/images/logout.jpg">
        <v-card-title class="image-text" >{{ $t(titleKey) }}</v-card-title>
      </v-img>
      <v-card-subtitle>{{ $t(subtitleKey) }}</v-card-subtitle>
      <v-card-text>
        {{ $t(messageKey) }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SmsLogOut',
  props: {
    messageKey: {
      type: String,
      default: 'message'
    },
    titleKey: {
      type: String,
      default: 'title'
    },
    subtitleKey: {
      type: String,
      default: 'subtitle'
    }
  }
};
</script>

<style scoped>
.main-card {
  max-width: 500px;
}
</style>
